module.exports = __webpack_public_path__ + "static/media/F-1-1-mobile.fffe6530.webp";